import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormService } from '../../services/form.service';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
import { StudentModel } from '@generativ/much-smarter-models';
import { ContentfulService } from '../../../shared/contentful.service';
import { EntryDictionary, LogInType } from '@generativ/ms-student-types';
import { FeedbackComponent } from '../../feedback/feedback/feedback.component';

@Component({
    selector: 'app-demographics',
    templateUrl: './demographics.component.html',
    styleUrls: ['./demographics.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, FeedbackComponent]
}) export class DemographicsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  demographicsForm: UntypedFormGroup;
  loading = true;
  content: LogInType;
  isUk: boolean = window.location.href.includes('games.muchsmarter.co.uk');
  // isUk: boolean = true;

  constructor(
    public formService: FormService,
    private authService: AuthService,
    private router: Router,
    private contentfulService: ContentfulService
  ) {
    this.demographicsForm = this.formService.createForm(this.formOptions);
    this.contentfulService.getStudentEntry(EntryDictionary.LogIn.logIn).then(
      (entry) => {
        this.content = new LogInType(entry);
        this.loading = false;
      }
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.demographicsForm)) {
      const tagNames: string[] = [];
      if (!this.isUk) {
        tagNames.push(this.demographicsForm.controls.question1.value);
      }
      tagNames.push(this.demographicsForm.controls.question2.value);
      tagNames.push(this.demographicsForm.controls.question3.value);
      tagNames.push(this.demographicsForm.controls.question4.value);
      if (this.demographicsForm.controls.email.value && !this.isUk) {
        tagNames.push('games-practice plan');
      }

      this.loading = true;

        this.authService.addDemographicTags(tagNames)
          .subscribe({
            next: (student) => {
            this.authService.setCurrentStudent(new StudentModel().parse(student));
            this.router.navigate(['/signup/payment']);
            },
            error: () => {
              this.loading = false;
            // this.authService.setCurrentStudent(new StudentModel().parse(student));
              this.router.navigate(['/signup/payment']);
            }

          })
      
    }
  }

  logout(): void {
    this.loading = true;
    this.authService.logout();
  }

  private get formOptions(): Record<string, unknown> {
    if (this.isUk) {
      return {
        email: null,
        question2: [
          null,
          Validators.compose([
            Validators.required
          ])
        ],
        question3: [
          null,
          Validators.compose([
            Validators.required
          ])
        ],
        question4: [
          null,
          Validators.compose([
            Validators.required
          ])
        ],
      };
    }
    return {
      email: null,
      question1: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      question2: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      question3: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      question4: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
    };
  }

}
